import { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import { captureScreenshot } from '../../services/feedbackService';

export default function FeedbackButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialScreenshot, setInitialScreenshot] = useState(null);

  const handleOpenModal = async () => {
    // Capture screenshot BEFORE opening modal (so the overlay isn't visible)
    try {
      const blob = await captureScreenshot();
      setInitialScreenshot(blob);
    } catch (err) {
      console.error('Failed to capture screenshot:', err);
      setInitialScreenshot(null);
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setInitialScreenshot(null);
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        className="fixed bottom-4 left-4 z-50 flex items-center justify-center size-10 rounded-full btn-gradient shadow-md shadow-eq-primary/20 hover:scale-110 transition-all duration-200 font-display"
        aria-label="Gi tilbakemelding"
      >
        <span className="material-symbols-outlined text-[18px]">chat_bubble</span>
      </button>

      {isModalOpen && (
        <FeedbackModal
          onClose={handleCloseModal}
          initialScreenshotBlob={initialScreenshot}
        />
      )}
    </>
  );
}
